import { store } from "../state/StateStore";
import { StageConfig } from "../data/StageConfig";

export class StageSystem {
  /** Advance to next stage */
  advanceStage(): void {
    const state = store.get();
    store.set({
      stage: state.stage + 1,
      blocksRemaining: StageConfig.blockCount,
      stageStartTime: Date.now(),
    });
  }

  /** Mark a block as removed */
  blockRemoved(): void {
    const state = store.get();
    store.set({
      blocksRemaining: Math.max(0, state.blocksRemaining - 1),
    });
  }

  /** Check if all blocks are cleared */
  isStageClear(): boolean {
    return store.get().blocksRemaining <= 0;
  }

  /** Get current stage */
  getCurrentStage(): number {
    return store.get().stage;
  }

  /** Initialize stage start time */
  startStage(): void {
    store.set({ stageStartTime: Date.now() });
  }
}
